// Promo codes reachable via /edgeboard?showUpgrade=true&promo=CODE.
// `interval` locks the upgrade dialog to one plan: Stripe coupons are scoped to
// the product, not the price, so a monthly offer would otherwise discount the
// annual plan too. `monthlyPrice` is what the monthly tile shows after the code.
export const PROMOS = {
  WINBACK24: { label: 'Welcome back: 50% off' },
  LEGACY10: { label: 'Legacy pricing: $10/mo' },
  LEGACY100: { label: 'Legacy pricing: $100/yr' },
  LEGACY12: { label: 'Legacy pricing: $12/mo' },
  LIST30: { label: 'Email offer: $12 off every month', interval: 'monthly', monthlyPrice: '$30' },
};

// Codes are letters and digits. A link pasted from a sentence arrives as
// "LIST30." and Stripe rejects it, so strip anything else; Stripe ignores case.
export const normalizePromo = (code) => (code || '').replace(/[^a-z0-9]/gi, '').toUpperCase() || null;

export const getPromo = (code) => PROMOS[normalizePromo(code)];

// Auth0's verification email lands on a fixed URL (/edgeboard), so a code seen
// before signup is kept here for a day. Same pattern as `trialIntent`, and the
// later of the two wins: saving a code clears a trial request, and startTrial
// clears a saved code.
const PENDING_KEY = 'pendingPromo';
const PENDING_TTL_MS = 24 * 60 * 60 * 1000;

export const savePendingPromo = (code) => {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify({ code, at: Date.now() }));
    localStorage.removeItem('trialIntent');
  } catch (e) {}
};

export const clearPendingPromo = () => {
  try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
};

// The saved code, or null. A stale entry is removed on the way.
export const readPendingPromo = () => {
  try {
    const pending = JSON.parse(localStorage.getItem(PENDING_KEY));
    if (pending && Date.now() - pending.at < PENDING_TTL_MS) return normalizePromo(pending.code);
  } catch (e) {}
  clearPendingPromo();
  return null;
};
